import { Type } from '@fullstory/proto/fs/api/vars';
import {
  GetCustomSchemaResponse,
  GetCustomSchemaConnectionsResponse,
} from '@fullstory/proto/fs/services/fieldmeta';
import { timestamp } from '@fullstory/proto/google/protobuf';

export const EMPTY_CUSTOM_SCHEMA_RESPONSE: GetCustomSchemaResponse = {
  customSchema: {
    userProperties: [],
    pageProperties: [],
    events: [
      {
        name: 'Checkout',
        approximateLastSeen: '2023-05-01T14:55:31.807922Z' as timestamp,
      },
    ],
    eventProperties: [
      {
        name: 'price',
        type: Type.real,
        approximateLastSeen: '2023-05-01T14:55:31.807922Z' as timestamp,
      },
    ],
    elementProperties: [],
  },
  customSchemaCounts: {
    userProperties: 0,
    pageProperties: 0,
    events: 1,
    eventProperties: 1,
    elementProperties: 0,
  },
  customSchemaLimits: null,
};

export const EMPTY_CUSTOM_SCHEMA_CONNECTIONS_RESPONSE: GetCustomSchemaConnectionsResponse = {
  customSchemaConnections: null,
};
